module.exports = __webpack_public_path__ + "img/02.e34cdff1.jpg";